const getServiceHistory = (services: any) => {
  let data: any = [];
  services.forEach((service: any) => {
    service.list.forEach((item: any) => {
      data.push(item);
    });
  });
  return data;
};

export default getServiceHistory;
